import {createSelector} from 'reselect';
import {getSettings} from './selectors';

export default createSelector(
  [getSettings],
  settings => (
    !!settings?.is_autofill_listener_disabled
  ),
);
